import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import { authActions, authSelectors, LOGIN_STATUS, USER_UPDATE_COMPLETE } from '@rosetta/react-auth/dist/index';
import { appActions, LOG_LEVEL, TRANSACTION_STATE } from '../../app/reducer/app-reducer';
import { getLearnerDashboard } from '../services/dashboard-api';
import { launchpadActions } from '../reducer/launchpad-reducer';
import { SET_GOALS } from '../reducer/goals-reducer';
import {
  KEY_USAGE_GOAL_DAYS,
  KEY_USAGE_GOAL_MINUTES,
  logBrazeEvent,
  setBrazeUserAttribute
} from '../../../helpers/engagementHelper';

function* updateGoals(action) {
  const updatedGoals = action.payload.updatedGoals;

  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const status = yield select(authSelectors.loginStatus);
    const haveUser = status === LOGIN_STATUS.LOGGED_IN;
    if (haveUser) {
      // update the user

      yield put(authActions.updateUser(updatedGoals));
      yield take(USER_UPDATE_COMPLETE);
      yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
      // TODO: close goals popup.

      let authToken = yield select(authSelectors.authToken);
      const userId = yield select(authSelectors.userId);
      yield put(launchpadActions.setDashboardLoading(true));
      const learnerDashboard = yield call(getLearnerDashboard, userId, authToken);
      yield put(launchpadActions.setDashboardLoading(false));

      // Notify engagement service about the goals for this user.
      logBrazeEvent('GoalsSet', {
        minsWeek: updatedGoals.usageGoalMinutes,
        daysWeek: updatedGoals.usageGoalDays
      });
      setBrazeUserAttribute(KEY_USAGE_GOAL_DAYS, updatedGoals.usageGoalDays);
      setBrazeUserAttribute(KEY_USAGE_GOAL_MINUTES, updatedGoals.usageGoalMinutes);

      if (learnerDashboard) {
        yield put(launchpadActions.setDashboard(learnerDashboard));
      }
    } else {
      throw new Error('user not logged in');
    }
  } catch (ex) {
    let errorMsg = 'error saving user preferences: ' + ex.message;
    yield put(
      appActions.logEvent({
        level: LOG_LEVEL.ERROR,
        message: errorMsg
      })
    );
    return yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, errorMsg));
  }
}

export function* goalsSagas() {
  yield takeLatest(SET_GOALS, updateGoals);
}



// WEBPACK FOOTER //
// ./src/modules/launchpad/sagas/goals-sagas.js